import axios from 'axios';
import { handleServerErrors, persistentHandler } from '../registration/util/error';
import { dispatch } from 'nike-re-framejs';
import { createPayload } from '../2fa';
import { getConfig } from '../registration/util/config';
import { REASON_2FA } from '../2fa/views/reason';
import { PATH } from './util/paths';
import forumClient from '../../common/axios/forumClient';

export let context = {};

function request2Fa(methods, reason, payload, callback) {
    return db => {
        context.twoFactorContext.onStart2Fa({ jwt: null, methods }, reason, payload, callback);
    };
}

function clientChangeRequest(changes, form, token2fa) {
    return axios.post('/api/client-params/change', { changes, token2fa });
}

function handleCTErrors(form) {
    return handleServerErrors(form, {
        codeHandlers: {
            '2FA_PAYLOAD_MISMATCH': persistentHandler(
                PATH.SERVER_INFO,
                'nui.client.param.change.error.2FA_PAYLOAD_MISMATCH'
            ),
            VERIFICATION_NOT_FOUND: persistentHandler(
                PATH.SERVER_INFO,
                'nui.client.param.change.error.VERIFICATION_NOT_FOUND'
            )
        },
        uiWrapper: a => a,
        finalHandler: error => {
            getConfig().open('ERROR', { status: error.response.status, code: error.response.data.code });
        }
    });
}

function onDoneHandler(result, cbOnDone) {
    if (cbOnDone) {
        cbOnDone(result);
    }
    getConfig().refreshUserData();
}

export function sendRequest(changeEntries, form, cbOnDone, reason = REASON_2FA.PERSONAL_DATA) {
    return clientChangeRequest(changeEntries, form, null)
        .then(result => onDoneHandler(result, cbOnDone))
        .catch(error => handleRequestError(error, changeEntries, form, reason, cbOnDone))
        .catch(handleCTErrors(form));
}

export function cancelRequest(type) {
    return axios
        .delete(`/api/client-params/authorize-contact/${type}`)
        .then(forcedActionsCrm => dispatch(setForcedActionsCrm(forcedActionsCrm)))
        .catch(handleCTErrors);
}

export function chechHasUnevaluatedAnalysis(nickname) {
    forumClient
        .get(`/v5/betbook/authors/${nickname}/has-not-evaluated-analysis`)
        .then(response => dispatch(hasEvaluatedLoader(response)));
}
const hasEvaluatedLoader = data => db => db.setIn(['betbook', 'hasRewards'], data);

function handleRequestError(error, changeEntries, form, reason, cbOnDone) {
    if (error?.response?.status === 403 && error?.response?.data?.code === 'AUTH_REQUIRED_2FA') {
        const request2FaCallback = token =>
            clientChangeRequest(changeEntries, form, token)
                .then(disablePopupDataChangeVerification)
                .then(forcedActionsCrm => dispatch(setForcedActionsCrm(forcedActionsCrm)))
                .then(result => onDoneHandler(result, cbOnDone))
                .catch(handleCTErrors(form));
        const payload = createPayload(changeEntries);

        dispatch(request2Fa(error.response.data.methods, reason, payload, request2FaCallback));
        return Promise.resolve();
    } else {
        return Promise.reject(error);
    }
}

function disablePopupDataChangeVerification(result) {
    sessionStorage.setItem('data-change-verification', false);
    dispatch(disableDataChangeVerification);
    return result;
}

export const disableDataChangeVerification = db => db.setIn(['data-change-verification'], false);

export const setForcedActionsCrm = forcedActionsCrm => db => getConfig().setForcedActionsCrm(forcedActionsCrm, db);

export const startClientParamChangeVerification = forcedActionCrm => () =>
    getConfig().open('CLIENT_PARAM_CHANGE_VERIFICATION', { forcedActionCrm });
